/**
 * 客户端useragent识别
 */
import cookie from 'js-cookie'
import url from '@common/url'

const ua = window.navigator.userAgent.toLowerCase()
const result = {
  // os
  isIOS: false,
  isAndroid: false,
  isWindows: false,
  isLinux: false,
  isUnix: false,
  isMac: false,

  // browser
  isSafari: false,
  isChrome: false,
  isIE: false,
  isEdge: false,
  isFirefox: false,
  isOpera: false,
  isUC: false,

  // app
  isWechat: false, // 微信
  isWeibo: false, // 新浪微博
  isQQ: false, // QQ
  isSuishouji: false, // 随手记
  isYunzhijia: false, // 云之家
  isKaniu: false, // 卡牛
  isSuiguanjia: false, // 随管家

  // device
  isIPhone: false,
  isIPhoneX: false,
  // isIPhoneXSMax: false, // XR 和 XSMax 暂时识别为 XSMax
  isIPhoneFullScreen: false,
  isIPad: false,
  isIPod: false,
  // isXiaomi: false,

  isMobile: false,
  isPC: false,

  // 各种比较详细的信息，比如操作系统版本号和名字，app版本号和名字，浏览器版本号和名字等。（统计不完全）
  browser: {},
  os: {},
  app: {},
  device: {},
  // 下面的写法已废弃，请用上面的写法
  detail: {
    browser: {},
    os: {},
    app: {},
    device: {}
  }
}

// os + device
if (/ipad/i.test(ua)) {
  result.detail.device.name = result.device.name = 'iPad'
  result.device.name = 'iPad'
  result.isIPad = true
} else if (/ipod/i.test(ua)) {
  result.detail.device.name = result.device.name = 'iPod'
  result.isIPod = true
} else if (/iphone/i.test(ua)) {
  result.detail.device.name = result.device.name = 'iPhone'
  result.isIPhone = true
} else if (/mac os x/i.test(ua)) {
  result.detail.device.name = result.device.name = 'Mac'
  result.isMac = true
} else if (/android/i.test(ua)) {
  const matches = ua.match(/android[_ ](\d+)[_\.](\d+)([_\.]\d+)?[; ]/g)
  result.detail.os.name = result.os.name = 'Android'
  result.detail.os.version = result.os.version = matches ? matches[0].replace(/;/g, ' ').trim().replace(/_/g, ' ').split(' ')[1] : ''
  result.isAndroid = true
} else if (/windows/i.test(ua)) {
  result.detail.os.name = result.os.name = 'Windows'
  result.isWindows = true
} else if (/linux/i.test(ua)) {
  result.detail.os.name = result.os.name = 'Linux'
  result.isLinux = true
} else if (/unix/i.test(ua)) {
  result.detail.os.name = result.os.name = 'Unix'
  result.isUnix = true
}

if (result.isIPhone || result.isIPad || result.isIPod) {
  const matches = ua.match(/os (\d+)[_\.](\d+)([_\.]\d+)? /g)
  result.detail.os.version = result.os.version = matches ? matches[0].trim().split(' ')[1].replace(/_/g, '.') : ''
  result.isIOS = true
}

// 临时添加此变量，后续要区分 XSMax 和 XR
let isIPhoneXSMaxOrXR = false

if (result.isIPhone && window.screen.height === 812 && window.screen.width === 375) {
  result.isIPhoneX = true
}
if (result.isIPhone && window.screen.height === 896 && window.screen.width === 414) {
  isIPhoneXSMaxOrXR = true
}
if (result.isIPhoneX || isIPhoneXSMaxOrXR) {
  result.isIPhoneFullScreen = true
}

// browser
if (/edge/i.test(ua)) {
  result.detail.browser.name = result.browser.name = 'Edge'
  result.isEdge = true
} else if (/chrome|crios/i.test(ua)) {
  const matches = ua.match(/(chrome|crios)\/[\d\.]+ /g)
  result.detail.browser.version = result.browser.version = matches ? matches[0].trim().split('/')[1] : ''
  result.detail.browser.name = result.browser.name = 'Chrome'
  result.isChrome = true
} else if (result.isIOS && /version\/(\d+)/i.test(ua)) {
  const matches = ua.match(/version\/[\d\.]+ /g)
  result.detail.browser.version = result.browser.version = matches ? matches[0].trim().split('/')[1] : ''
  result.detail.browser.name = result.browser.name = 'safari'
  result.isSafari = true
} else if (/msie|trident/i.test(ua)) {
  result.detail.browser.name = result.browser.name = 'IE'
  result.isIE = true
} else if (/ucbrowser/i.test(ua)) {
  result.detail.browser.name = result.browser.name = 'UC Browser'
  result.isUC = true
} else if (/opera/i.test(ua)) {
  result.detail.browser.name = result.browser.name = 'Opera'
  result.isOpera = true
} else if (/firefox/i.test(ua)) {
  result.detail.browser.name = result.browser.name = 'Firefox'
  result.isFirefox = true
}

// app
if (/micromessenger/i.test(ua)) {
  result.detail.app.name = result.app.name = 'Wechat'
  result.isWechat = true
} else if (/weibo/i.test(ua)) {
  result.detail.app.name = result.app.name = 'Weibo'
  result.isWeibo = true
} else if (/qq\//i.test(ua)) {
  result.detail.app.name = result.app.name = 'QQ'
  result.isQQ = true
} else if (/qing\//i.test(ua)) {
  result.detail.app.name = result.app.name = 'yunzhijia'
  result.isYunzhijia = true
} else if (/mymoneysms/i.test(ua) || url('?sub_client') === 'cardniu' || cookie.get('lc_sub_client') === 'cardniu') {
  const matches = ua.match(/(mymoneysms|cardniuandroidversion)[\d.]+/g)
  const version = matches && matches[0].replace(/[^0-9.]/g, '')
  result.detail.app.version = version
  result.detail.app.name = result.app.name = 'kaniu'
  result.isKaniu = true
} else if (/(feideeandroid|mymoney)/i.test(ua)) {
  const matches = ua.match(/(mymoney|mymoneypro|mymoneyenterprise|mymoneyexpress)\/[\d.]+/g)
  let version = matches && matches[0].replace(/[^0-9.]/g, '')
  // 兼容旧版本的客户端
  if (!version) {
    if (result.isIOS) {
      version = window.FDMarketMetaNew ? window.FDMarketMetaNew.AppVersion : ''
    } else {
      version = window.FDMarketMeta ? window.FDMarketMeta.AppVersion : ''
    }
  }
  result.detail.app.version = result.app.version = version
  result.detail.app.name = result.app.name = 'suishouji'
  result.isSuishouji = true
} else if (/suiguanjia/i.test(ua)) {
  const matches = ua.match(/suiguanjia\/[\d.]+/i)
  const version = matches && matches[0].replace(/[^0-9.]/g, '')
  result.detail.app.version = result.app.version = version
  result.detail.app.name = result.app.name = 'suiguanjia'
  result.isSuiguanjia = true
}

if (/mobile/i.test(ua)) {
  result.isMobile = true
} else {
  result.isPC = true
}

/**
 * 判断ua是否包含特定字符串
 * @param {string} keyword 要判断的字符串
 */
result.is = function(keyword) {
  return !!keyword && ua.indexOf(keyword) > -1
}

export default result
